// DaysOfWeekGrid.js
import React from "react";
import "./Components.css";  // some optional CSS
import pt from "../i18n/pt.json";
import en from "../i18n/en.json";
import de from "../i18n/de.json";
import { useLanguage } from "../context/LanguageContext";

function DaysOfWeekGrid({ value, onChange }) {
  const { t } = useLanguage();
  const DAY_LABELS = t("weekday_initials");
  // 'value' is an array of booleans, e.g. [false, true, ...]
  // 'onChange' is a callback(newArrayOfBooleans)

  // If 'value' is not provided, default to all false
  const days = value || Array(7).fill(false);

  function handleClick(index) {
    const newDays = [...days];
    newDays[index] = !newDays[index];
    onChange(newDays);
  }

  return (
    <div className="days-of-week-grid">
      {DAY_LABELS.map((lbl, idx) => {
        const selected = days[idx];
        return (
          <div
            key={lbl}
            className={`day-cell ${selected ? "selected" : ""}`}
            onClick={() => handleClick(idx)}
          >
            {lbl}
          </div>
        );
      })}
    </div>
  );
}

export default DaysOfWeekGrid